// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import {
    chain,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { parseBoolean } from "@tps/XDL/Utilities";

interface CustomCartLineModel extends CartLineModel {
    properties: {
        warehouseId?: string;
    };
}
export const CustomPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }

    // XNG-Changes:Filter out the items that can't be added to cart
    props.apiParameter = {
        cartLines: order.value.orderLines!.reduce((acc, line: OrderLineModel) => {
            if (!parseBoolean(line.properties.canNotAdd)) {
                acc.push({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                    // XNG-Changes: adding warehouseId in the lines
                    properties: {
                        warehouseId: (line as any)?.properties?.warehouseId,
                    },
                } as CustomCartLineModel);
            }
            return acc;
        }, <CustomCartLineModel[]>[]),
    } as CartLineCollectionModel;
};
// XNG-Changes: pass apiResult
export const XngExecuteOnSuccessCallback: typeof ExecuteOnSuccessCallback = props => {
    const parameter = props.parameter as typeof props.parameter & HasOnSuccess<CartLineCollectionModel>;
    parameter.onSuccess?.(props.apiResult);
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
